import cn from 'classnames';
import React, { memo } from 'react';

import { useIsMobile } from '@sravni/react-utils';
import { getVariantHelper } from '@sravni/vitrina/lib/helpers/getVariantHelper';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import { useProductConfig } from '../../../../../../store/hooks/productPopupInfo';
import type { ICON_SIZES } from '../../constants/icon';

import Widget from './components/Widget';
import style from './style.module.scss';

interface IWidgetsProps {
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  widgetClassName?: string;
  product: IProduct;
  iconSize?: typeof ICON_SIZES[keyof typeof ICON_SIZES];
}

const Widgets: React.FC<IWidgetsProps> = memo((props) => {
  const { className, iconClassName, labelClassName, widgetClassName, product, iconSize } = props;
  const isMobile = useIsMobile();
  const {
    list: { mobile, desktop },
  } = useProductConfig();
  const { widgets } = (isMobile ? mobile : desktop).productInfo;

  return (
    <div className={cn(className, style.wrapper)}>
      {widgets.map((widget, index) => {
        const key = `widget-${index}`;
        const config = 'variants' in widget ? getVariantHelper(widget.variants, {}, product) : widget;

        return (
          <Widget
            key={key}
            config={config}
            product={product}
            className={widgetClassName}
            iconClassName={iconClassName}
            iconSize={iconSize}
            labelClassName={labelClassName}
          />
        );
      })}
    </div>
  );
});

export default Widgets;
